import React from 'react';
import {Link} from 'react-router-dom';
import MemberNavigation from './MemberNavigation';
const primary=[{path:'/',label:'BOARD'},{path:'/strategy-scoreboard',label:'SCOREBOARD'},{path:'/quick-picks',label:'QUICK PICKS'}];
// Shared signed-in chrome: client-side links preserve the current auth session.
export default function MemberHeader({tabs=primary,isAdmin=false,onFeedback,onSignOut}){
 return <header className="hdr customer-header"><Link to="/" className="member-home" aria-label="LottoTracker — Board"><div className="logo">Lotto<span>Tracker</span></div><div className="logo-sub">Today's Picks</div></Link><MemberNavigation tabs={tabs} isAdmin={isAdmin} onFeedback={onFeedback} onSignOut={onSignOut}/></header>;
}
